export const DEFAULT_TESTIMONIALS = [
    {
        id: "testimonial-sortland",
        title: "Et integrativt og pedagogisk kurs",
        quote: "Det beste med kurs i bekymringsmestring er at det samler alle de beste verktøyene fra ulike terapiformer i et kurs. Det gjør at «alle» finner noen verktøy som passer for dem. Kursboken og kurset fremstiller stoffet på en pedagogisk og respektfull måte. Jeg bruker stoffet fra kurs i bekymringsmestring mye i individuell oppfølging, og ikke minst i eget liv. Kurset har betydd mye for min arbeidsplass. Det har fått ned ventelistene, men ikke minst får vi veldig gode tilbakemeldinger fra deltakerne. Både personer som aldri har vært i oppfølging, og personer som har gått mange år i individualterapi har godt utbytte. Mange sier de skulle ønske de hadde lært disse verktøyene tidligere. Jeg anbefaler kurs i bekymringsmestring på det sterkeste!",
        author: "Hilde Harstveit Ljosland",
        role: "Psykisk helsearbeider",
        organization: "Sortland kommune",
        order: 1,
        published: true,
    },
    {
        id: "testimonial-oksnes",
        title: "Å tørre å møte det vonde",
        quote: "Kurs i Bekymringsmestring hjelper både terapeut og deltager til å bli tryggere på de vonde følelsene, slik at vi sammen kan møte dem med vennlighet og varme.",
        author: "Marte S. Stranda",
        role: "Fagansvarlig, Psykisk helse og rustjenesten",
        organization: "Øksnes kommune",
        order: 2,
        published: true,
    },
    {
        id: "testimonial-ringsaker",
        title: "Et transdiagnostisk kurs",
        quote: "Kurs i Bekymringsmestring er herlig transdiagnostisk, og tar for seg helheten og kompleksiteten i det å være menneske!",
        author: "Anna Kolsrud",
        role: "Kursholder",
        organization: "Ringsaker kommune",
        order: 3,
        published: true,
    },
];
